import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StatusContainer = styled(Box)(({ status }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '18.2px',
  minWidth: '120px',
  gap: '10px',
  padding: '4px',
  borderRadius: '20px',
  fontSize: '12px',
  fontWeight: 700,
  fontFamily: 'Archivo',
  color: '#f5f1f9',
  backgroundColor: status !== 'Pending' ? '#1b9390' : '#979797',
}));

export default StatusContainer;
